module.exports = __webpack_public_path__ + "img/bookWhite.399bee87.svg";